export default "__VITE_ASSET__Bb1iP1_3__"